/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {PAGE_NUMBER, PAGE_SIZE} from '../../container/BuiltinPolicies/constants';

export interface IBuiltInPolicyItem {
  id: number,
  displayName: string;
  description: string;
  expression: string;
  rule?: string;
}

export interface IBuiltInPoliciesTableData {
  tableData: IBuiltInPolicyItem[];
  handleEditPolicy: (rowData: IBuiltInPolicyItem) => void;
  handleDeletePolicy: (rowData: IBuiltInPolicyItem) => void;
}

export interface IPage {
  sortFields?: string[];
  pageNumber: number;
  pageSize: number;
  lastPage?: boolean;
  pageCount?: number;
  count?: number;
}

export interface IBuiltinPoliciesData {
  entities: IBuiltInPolicyItem[];
  meta: {
    page: IPage;
  };
}

export const pageData: IPage = {
  pageNumber: PAGE_NUMBER,
  pageSize: PAGE_SIZE,
};

export interface IBuiltinPoliciesSearch {
  'module-id'?: number;
  'page-number': number;
  'page-size': number;
}

export const builtinPoliciesDefaultSearchParams: IBuiltinPoliciesSearch = {
  'page-number': PAGE_NUMBER,
  'page-size': PAGE_SIZE,
};
